module.exports = __webpack_public_path__ + "img/ring_skip_skip_null_0@3x.36dacfea.png";